import { withBreakpointObserver } from '@studiometa/js-toolkit';
import {
  Slider as SliderCore,
  SliderItem,
  SliderDrag,
  SliderBtn,
} from '@studiometa/ui';
import GalleryDots from './GalleryDots.js';

/**
 * Slider component
 */
export default class Slider extends withBreakpointObserver(SliderCore) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    components: {
      SliderItem,
      SliderDrag,
      SliderBtn,
      GalleryDots,
    },
  };

  mounted() {
    super.mounted();
  }
}
